// CONSTANTS are all caps.
const NS = "ChatbotBlock";
const CLS = "chatbotBlock";

export class ChatbotBlock {
	constructor($el) {
		// $el is the widget node return by the loadChatbotButton function
		this.$el = $($el);
		this.chatbotIcon = this.$el.find('.chatbotIcon');
		this.chatbotBox = this.$el.find('.chatbotBox');
		this.chatbotClose = this.$el.find('.chatbotClose');
		this.submit = this.$el.find('#submit');
		this.response = this.$el.find('#response');
		this.question = this.$el.find('#question');
        this.endpointUrl = this.$el.data('endpoint');

		this.chatbotClose.on('click', (e) => {
			if(this.chatbotBox.hasClass('show')){
				this.chatbotBox.removeClass('show');
			}
		});
		this.chatbotIcon.on('click', (e) => {
			if(!this.chatbotBox.hasClass('show')){
				this.chatbotBox.addClass('show');
			}
		});

		this.submit.on('click', (e) => {
            this.response.empty();
            this.submit.attr('disabled', 'disabled').css("background-color", "#ddd");
            var prompt = this.question.val() +"and give response in sheep puns no citations please";
            var typed = null;
            this.response.append("<div class='typingImag'></div>"); 
			$.ajax({
                type: "POST",
                url: this.endpointUrl + prompt,
                dataType: "json",
                success: function (data) {
                    if (typed != null) {
                        typed.destroy();
                    }
                    var a = data.choices;
                    $('#response').empty();

                    $('#question').prop("disabled", true);
                    var typedOptions = {
                        strings: [a[0].messages[1].content],
                        typeSpeed: 20,
                        showCursor: false,
                        onComplete: () => {
                           $('#submit').attr('disabled', false).css("background-color", "#000")
						   $('#question').prop("disabled", false);
                        }
                    };
                    typed = new Typed("#response", typedOptions);
                },
                error: function (jqXHR, status, error) {
                    $('#response').empty();
                    $('#response').append("<p style='color:red;'>Please try again later.</p>");
                    $('#submit').attr('disabled', false).css("background-color", "#000");
                    $('#question').prop("disabled", false);
                    console.error("Error:", status, error);
                    
                }
            });
        });
	}
}

